import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls the React Compiler build
 */
export const REACT_COMPILER_250528 = 'REACT_COMPILER_250528' as SettingConst<
  'REACT_COMPILER_250528',
  boolean,
  'RETAILER'
>;
